import Chart from '../vendors/chart.min';

export default function chart(canvasElement) {
    const ctx = $(canvasElement);
    const name = ctx.attr('data-name');
    let ctx_options = null;

    if(window[name]) {
      ctx_options = window[name];
    }

    if (ctx.length && ctx_options) {
        const chartStart = new Chart(ctx, ctx_options);
        return chartStart;
    }

    return null;
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/chart.js